import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-employeeManage",
  "use": "icon-employeeManage-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-employeeManage\"><path d=\"M890.594714 0.002276H131.584845C90.681825 0.002276 56.8899 33.737312 56.8899 76.403884v871.194508C56.8899 988.444523 90.681825 1024 133.405286 1024h757.189428c40.959909 0 76.515386-33.735036 76.515386-76.401608V76.403884A75.946498 75.946498 0 0 0 890.594714 0.002276z m-554.665434 922.735727H262.997887V95.802952h72.931393V922.738003z m435.597254-610.416421l-76.458496-76.401608-76.515386 76.401608V85.107864h151.039664V312.321582h1.934218z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/employeeManage.svg
// module id = /zg1
// module chunks = 78